import React from 'react';
import { optCollection } from './BasicOperate';
import { dispatch, getState } from '@@/store';
import { showInitiateDispute, showDaYuDispute } from '@/shared/utils';
import { Modal, Icon } from 'antd';
export function waitSignContractColumn(props) {
    const { pageIdentification, record, orderCallback } = props;
    return optCollection({
        pageIdentification,
        record,
        // 成交合同签署
        signContractClick: () => {
            opt.signContractClick(record, orderCallback);
        },
        // 争议
        disputeClick: () => {
            opt.handleTransfer(record, orderCallback);
        },
        // 跳过签署合同
        skipSignContractClick: () => {
            opt.changeModalVisible(record, orderCallback);
        },
        // 出价详情
        bidDetailsCilck: () => {
            dispatch.router.push({
                path: '/carManage/offerdetails',
                query: {
                    id: record.auctionId,
                },
            });
        },
    });
}
const opt = {
    // 成交合同签署
    signContractClick(record, orderCallback) {
        const { pageCurrent } = getState().waitSign;
        dispatch.waitSign.getContract({
            orderId: record.orderId,
            callback: () => {
                orderCallback ? orderCallback() :
                    (dispatch.waitSign.updateTable(pageCurrent), dispatch.winBiddingCar.getOrderCountInfoApi({}));
            }
        });
    },
    // 争议
    handleTransfer(record, orderCallback) {
        if (record.actionType === 10 && record.orderTag === 1) {
            showDaYuDispute({
                data: record,
                callback: () => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        const { pageCurrent } = getState().waitSign;
                        dispatch.waitSign.updateTable(pageCurrent);
                        dispatch.winBiddingCar.getOrderCountInfoApi({});
                    }
                },
            });
        }
        else {
            showInitiateDispute({
                data: record,
                lubanType: 0,
                callback: () => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        const { pageCurrent } = getState().waitSign;
                        dispatch.waitSign.updateTable(pageCurrent);
                        dispatch.winBiddingCar.getOrderCountInfoApi({});
                    }
                },
            });
        }
    },
    // 跳过签署合同
    changeModalVisible(record, orderCallback) {
        const { pageCurrent } = getState().waitSign;
        Modal.confirm({
            icon: <Icon type="exclamation-circle" theme="filled"/>,
            title: '确定跳过合同签署？',
            okText: '确认',
            onOk() {
                dispatch.waitSign.shipSignContract(record.orderId).then(() => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        dispatch.waitSign.updateTable(pageCurrent);
                        dispatch.winBiddingCar.getOrderCountInfoApi({});
                    }
                });
            },
        });
    },
};
